import type { FilterOptionCatalogEntry } from '@/app/components/shared/ListingFilters/mergeFilterOptionsWithCatalog'

import type { DateRangeValue } from './FinDeSemana.types'

/** Antetítulo fijo, literal — nunca proviene del payload (spec.md FR-003/FR-007,
 * mismo criterio que `Productos`/`KICKER_LABEL`). */
export const KICKER_LABEL = 'Recomendados'

/** Chip seleccionada por defecto en la carga inicial (spec.md FR-006). */
export const DEFAULT_DATE_RANGE: DateRangeValue = 'weekend'

/** Mismo catálogo de 5 chips que `DATE_RANGE_CATALOG`
 * (`shared/ListingFilters/dateRangeCatalog.ts`) — duplicado literal (no
 * importado) porque ese catálogo está tipado como `string` genérico y este
 * módulo necesita la unión literal `DateRangeValue` para su propio estado
 * (`FinDeSemana.types.ts`). Mismos `value`/`label`, mismo orden (spec.md
 * FR-005). */
export const DATE_RANGE_TABS: readonly (FilterOptionCatalogEntry & { readonly value: DateRangeValue })[] = [
  { value: 'today', label: 'Hoy' },
  { value: 'weekend', label: 'Este fin de semana' },
  { value: 'week', label: 'Esta semana' },
  { value: 'month', label: 'Este mes' },
  { value: 'next_month', label: 'El mes que viene' },
]

export const EMPTY_STATE_TITLE =
  'No hay eventos para esta combinación de provincia y periodo.'

/** Nombre accesible del `LoadingOverlay` general del sitio mientras navega a
 * la variante localizada de la página tras elegir otra provincia — mismo
 * patrón que `AgendaHeader`/`ProductosLocalizadosHeader`. */
export const LOCATION_CHANGE_LOADING_LABEL = 'Cargando eventos de la nueva localización'

/** Nombre accesible del mismo `LoadingOverlay` general mientras se resuelve
 * el refetch en segundo plano al cambiar de chip de periodo (corrección de
 * negocio: mismo indicador visual que el cambio de provincia). */
export const DATE_RANGE_CHANGE_LOADING_LABEL = 'Actualizando eventos del periodo elegido'
